// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4242":"6032c679","4838":"cba690a1","7265":"6032c679","8152":"ad27d30f","9723":"ad27d30f"}[chunkId] + ".chunk.css";
};